module.exports = __webpack_public_path__ + "static/ill2-9855ee9f8540e6fdf088df7ab3897ea7.svg";